/**
 * Shared brand mark — renders the actual Zion Solar logo.
 * Single source of truth for brand image so we never drift back to a placeholder.
 */
export default function BrandMark({ size = 36, className = "" }) {
  return (
    <img
      src="/zion-logo.png"
      alt="Zion Solar"
      width={size}
      height={size}
      data-testid="brand-mark"
      className={`block object-contain ${className}`}
      style={{ width: size, height: size }}
    />
  );
}
